import { multiSelectFilter, createActionsColumn, urlCell, longTextCell } from '../columnUtils';

export const createIcd10MaxNtaLookupColumns = (setSelectedItem, setDrawerVisible, handleDelete) => [
  {
    id: 'icd10Undotted',
    header: 'ICD10 Undotted',
    accessorKey: 'icd10Undotted',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'icd10',
    header: 'ICD10',
    accessorKey: 'icd10',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'shortDescription',
    header: 'Short Description',
    accessorKey: 'shortDescription',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'longDescription',
    header: 'Long Description',
    accessorKey: 'longDescription',
    size: 220,
    enableSorting: false,
    filterFn: multiSelectFilter,
    cell: longTextCell
  },
  {
    id: 'activeDxGroupCode',
    header: 'Active Dx Group Code',
    accessorKey: 'activeDxGroupCode',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'activeDxGroupName',
    header: 'Active Dx Group Name',
    accessorKey: 'activeDxGroupName',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'activeDxPoints',
    header: 'Active Dx Points',
    accessorKey: 'activeDxPoints',
    enableSorting: true,
    sortingFn: 'alphanumeric',
    filterFn: multiSelectFilter
  },
  {
    id: 'exactMappedCategories',
    header: 'Exact Mapped Categories',
    accessorKey: 'exactMappedCategories',
    enableSorting: false,
    filterFn: multiSelectFilter,
    cell: longTextCell
  },
  {
    id: 'exactMappedPoints',
    header: 'Exact Mapped Points',
    accessorKey: 'exactMappedPoints',
    enableSorting: true,
    sortingFn: 'alphanumeric',
    filterFn: multiSelectFilter
  },
  {
    id: 'maxTotalPointsAssumingActive',
    header: 'Max Total Points (Active)',
    accessorKey: 'maxTotalPointsAssumingActive',
    enableSorting: true,
    sortingFn: 'alphanumeric',
    filterFn: multiSelectFilter
  },
  {
    id: 'sourceUrlPoints',
    header: 'Source URL (Points)',
    accessorKey: 'sourceUrlPoints',
    enableSorting: false,
    enableColumnFilter: false,
    cell: urlCell
  },
  {
    id: 'sourceUrlMapping',
    header: 'Source URL (Mapping)',
    accessorKey: 'sourceUrlMapping',
    enableSorting: false,
    enableColumnFilter: false,
    cell: urlCell
  },
  createActionsColumn(setSelectedItem, setDrawerVisible, handleDelete)
];
